export class PurposeNeedVesselTypes {
  static FORBIDDEN_VESSEL = 0
  static FREE_VESSEL = 1
  static NEED_VESSEL = 2
}
